import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

import SkeletonField from './SkeletonField'
import SkeletonTable from './SkeletonTable'

export type SkeletonFormGridProps = {
    fields?: number
    rows?: number
    columns?: number
    toolbarIcons?: number
}

export default function SkeletonFormGrid(props: Readonly<SkeletonFormGridProps>) {
    const { fields = 4, rows = 12, columns = 4, toolbarIcons = 4 } = props

    return (
        <Grid container spacing={2} size={12}>
            <Grid size={12}>
                <Paper sx={{ p: 2 }}>
                    <Stack
                        direction="row"
                        sx={{ alignItems: 'center', justifyContent: 'space-between' }}
                    >
                        <Skeleton variant="text" width={180} sx={{ fontSize: '1.5rem' }} />
                        <Skeleton variant="circular" width={20} height={20} />
                    </Stack>
                </Paper>
            </Grid>

            <Grid size={12}>
                <Paper sx={{ p: 3 }}>
                    <Grid container spacing={4} rowSpacing={4}>
                        {Array.from({ length: fields }, (_, index) => (
                            <Grid key={index} size={{ xs: 12, md: 6 }}>
                                <SkeletonField />
                            </Grid>
                        ))}
                    </Grid>

                    <Stack direction="row" spacing={2} sx={{ justifyContent: 'center', py: 3 }}>
                        <Skeleton variant="rounded" width={280} height={40} />
                        <Skeleton variant="rounded" width={280} height={40} />
                    </Stack>

                    <Divider sx={{ mb: 2 }} />

                    <Box>
                        <Stack
                            direction="row"
                            spacing={1.5}
                            sx={{ justifyContent: 'flex-end', pb: 1.5 }}
                        >
                            {Array.from({ length: toolbarIcons }, (_, index) => (
                                <Skeleton key={index} variant="circular" width={22} height={22} />
                            ))}
                        </Stack>
                        <SkeletonTable rows={rows} columns={columns} showToolbar={false} />
                        <Stack direction="row" sx={{ justifyContent: 'flex-end', pt: 1.5 }}>
                            <Skeleton variant="text" width={140} />
                        </Stack>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    )
}
